export default {
    mask: {
        class: 'p-confirm-dialog-mask',
    },
    root: 'p-confirm-dialog-root',
    title: 'p-confirm-dialog-title',
};
